import { useParams } from "react-router-dom";
import Jupiter from "../../components/Jupiter/Jupiter";
import Header from "../../components/Jupiter/Header/Header";
import ApplicationDetail from "../../components/Jupiter/ApplicationDetail/ApplicationDetail";

const JupiterViewApplication = () => {
  const { id } = useParams();

  console.log("id", id);

  return (
    <>
      <Jupiter>
        <div className="container mx-auto px-4 py-8">
          <Header />
          <ApplicationDetail id={id} />
        </div>
      </Jupiter>
    </>
  );
};

export default JupiterViewApplication;
